import { CSSObject } from '@emotion/react'

const baseStyles: CSSObject = {
  backgroundColor: '#fff',
  border: 'none',
  borderRadius: 0,
  display: 'flex',
  flexDirection: 'column',
  padding: '20px 10px 20px 10px',
  width: 430,
}

export { baseStyles }
